import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from '@tradingblock/components';

interface FormNavigationProps {
  currentStep: number;
  steps: string[];
  setCurrentStep: (step: number) => void;
  isSubmitting: boolean;
  handleStepComplete: () => void;
  styles: any;
  handleSubmit: () => void;
  showContinueLink?: boolean;
  siteGrp?: string;
}

const FormNavigation: React.FC<FormNavigationProps> = ({
  currentStep,
  steps,
  setCurrentStep,
  isSubmitting,
  handleStepComplete,
  styles,
  handleSubmit,
  showContinueLink = false,
  siteGrp,
}) => (
  <>
    <div className="d-flex align-items-center gap-3 mt-2 mb-2">
      {currentStep > 0 && (
        <button
          type="button"
          className="btn-unified btn-unified--secondary"
          onClick={() => setCurrentStep(currentStep - 1)}
          aria-label="Go back to previous step"
        >
          <i className="fas fa-chevron-left me-2" aria-hidden="true"></i>
          Back
        </button>
      )}
      {currentStep < steps.length - 1 ? (
        <button
          type="submit"
          className="btn-unified btn-unified--primary"
          aria-label="Continue to next step"
          style={{ width: '100%' }}
        >
          Sign Up
        </button>
      ) : (
        <button
          type="submit"
          className={`btn-unified btn-unified--primary ${isSubmitting ? 'btn-unified--loading' : ''}`}
          disabled={isSubmitting}
          aria-label={isSubmitting ? 'Creating your account, please wait' : 'Sign up'}
          style={{ width: '100%' }}
        >
          {isSubmitting ? (
            <>
              <span className="visually-hidden">Creating your account...</span>
              <span aria-hidden="true">Creating your account...</span>
            </>
          ) : (
            <>Sign Up</>
          )}
        </button>
      )}
    </div>

    {/* Continue here link for existing applications */}
    {showContinueLink && (
      <div className="mt-1">
        <span style={{ color: '#ffffff' }}>
          <Text id="alreadyStartedApplication" page="home" />
        </span>
        <Link className="text-primary text-decoration-underline" to={siteGrp ? `/auth/?grp=${siteGrp}` : '/auth'}>
          <span style={{ color: '#19bab4', marginLeft: '4px' }}>
            <Text id="continueHere" page="home" />
          </span>
        </Link>
      </div>
    )}
  </>
);

export default FormNavigation;
